(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      // HADELE: this element is only given slidesPerViewDesktop, so the spacing
      // fell back to 2px while the recommendations slider used the theme's
      // spacing settings. Borrow those values from the other slider on the page
      // so both rows have identical gaps.
      let sharedSpacing = {};
      try {
        const others = document.querySelectorAll('card-product-slider[data-swiper-options], recently-viewed-products[data-swiper-options]');
        for (let i = 0; i < others.length; i++) {
          if (others[i] === this) continue;
          const parsed = JSON.parse(others[i].getAttribute('data-swiper-options')) || {};
          if (parsed.spaceBetweenDesktop !== undefined || parsed.spaceBetweenMobile !== undefined) {
            sharedSpacing = parsed;
            break;
          }
        }
      } catch (e) {}

      const spaceMobile = swiperOptions.spaceBetweenMobile !== undefined
        ? swiperOptions.spaceBetweenMobile
        : (sharedSpacing.spaceBetweenMobile !== undefined ? sharedSpacing.spaceBetweenMobile : 2);

      const spaceDesktop = swiperOptions.spaceBetweenDesktop !== undefined
        ? swiperOptions.spaceBetweenDesktop
        : (sharedSpacing.spaceBetweenDesktop !== undefined ? sharedSpacing.spaceBetweenDesktop : 2);

      // Mirror the recommendations slider exactly. Navigation stays scoped to
      // this section so the two sliders do not share arrow buttons.
      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: spaceMobile,
        slidesPerView: 'auto',
        resistanceRatio: 0.72,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: this.parent.querySelector('.swiper-button--next'),
          prevEl: this.parent.querySelector('.swiper-button--prev')
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: spaceDesktop
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: spaceDesktop
          }
        }
      };
    }

    initSlider() {
      super.initSlider();

      // HADELE: the section is rendered with the `hidden` class and only shown
      // once the slider has been built, so Swiper measures the container while
      // it is still hidden and sizes the slides against the wrong width. Reveal
      // it first, then force a re-measure now that it has a real width.
      this.parentElement.classList.remove('hidden');

      const refresh = () => {
        if (!this.slider || typeof this.slider.update !== 'function') return;
        try {
          this.slider.update();
          this.slider.slideTo(0, 0, false);
        } catch (e) {}
      };

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(refresh);
      }
      setTimeout(refresh, 100);
      setTimeout(refresh, 500);
      window.addEventListener('load', refresh);
    }
  }

  customElements.define(
    'complementary-products',
    ComplementaryProducts
  );
})();
